// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"902c54e8","488":"23240950","977":"25fc8c9d"}[chunkId] + ".chunk.js";
};